import { render } from "./StudentDetails.vue?vue&type=template&id=3271240e&ts=true"
import script from "./StudentDetails.vue?vue&type=script&lang=ts"
export * from "./StudentDetails.vue?vue&type=script&lang=ts"

import "./StudentDetails.vue?vue&type=style&index=0&id=3271240e&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/com.latudio.www.teachers_staging/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__